import { createContext, useContext, useState, useEffect, ReactNode, FC } from 'react'
import { useLocation } from 'react-router-dom'

type TopMenuChildComponentContextType = {
  topMenuChildComponent: ReactNode
  setTopMenuChildComponent: (topMenuChildComponent: ReactNode) => void
}

const TopMenuChildComponentContext = createContext<TopMenuChildComponentContextType | undefined>(
  undefined
)

export const RenderTopMenuChildComponentProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [topMenuChildComponent, setTopMenuChildComponent] = useState<ReactNode>(null)
  const location = useLocation()

  useEffect(() => {
    setTopMenuChildComponent(null)
  }, [location.pathname])

  return (
    <TopMenuChildComponentContext.Provider
      value={{ topMenuChildComponent, setTopMenuChildComponent }}
    >
      {children}
    </TopMenuChildComponentContext.Provider>
  )
}

export const useRenderTopMenuChildComponent = (): TopMenuChildComponentContextType => {
  const context = useContext(TopMenuChildComponentContext)
  if (!context) {
    throw new Error(
      'useRenderTopMenuChildComponent must be used within a RenderTopMenuChildComponentProvider'
    )
  }
  return context
}
